import { render, staticRenderFns } from "./ModalFormGeneric.vue?vue&type=template&id=4074a212&"
import script from "./ModalFormGeneric.vue?vue&type=script&lang=js&"
export * from "./ModalFormGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports